import { processesRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { EditProcessJson } from '../types';

export const useUpdateProcess = () =>
  useMutation<unknown, unknown, EditProcessJson>((process) =>
    processesRepo.updateProcess(process),
  );
